import { ajax } from '@tencent/qd-lib';
import formDataUrlList from '@/config/formDataUrl';
import loginPanel from '@/utils/loginCommon';
// 会存在没有code | r的情况，故创建白名单，在白名单里的接口直接返回数据
import whiteListUrl from '@/config/whiteListUrl';
// 针对页面上r非0或者code非0时，业务上有处理，需要返回res的接口
import businessErrorWhiteList from '@/config/businessErrorWhiteList';
const request = ajax.create({
    interceptors: {
        requestInterceptors: (config: any) => {
            config.nopermission = loginPanel;
            if (formDataUrlList.includes(config.originUrl)) config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
            return config;
        },
        responseInterceptors: (res: any) => {
            if (res && res.data && res.data.r === 0) return res;
            // 这段代码会影响业务中未处理r非0的情况，比如r非0时在页面还会报成功
            // // fix 这里r参数有值 也要返回 不然业务无法捕获到错误
            // if (res && res.data && res.data.r) return res;
            if (res && res.data && res.data.code !== 0) {
                if (res.config.customFn) {
                    res.config.customFn(res.data);
                } else {
                    if (whiteListUrl.includes(res.config.originUrl) || businessErrorWhiteList.includes(res.config.originUrl)) return res;
                    // @ts-ignore
                    !res.config.noShowMsg && window.vhtml?.Message?.error(res.data.msg || res.data.message || '信息加载出错，请稍后刷新重试');
                }
                return false;
            }
            return res;
        },
    },
});

request.crossGet = request.get;
request.crossPost = request.post;
request.read = request.get;
request.write = request.post;
request.update = request.put;
request.remove = request.delete;

export default request;
